import { Attribute } from "../../attribute.js";
export function hasName(nameOrPredicate, ...names) {
    let predicate;
    if (typeof nameOrPredicate === "function") {
        predicate = nameOrPredicate;
    }
    else {
        names.unshift(nameOrPredicate);
        predicate = (name, attribute) => names.some((candidate) => Attribute.foldCase(candidate, attribute.owner) === name);
    }
    return (attribute) => predicate(attribute.name, attribute);
}
//# sourceMappingURL=has-name.js.map